import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import statusConfig from '../helpers/statusConfig';

const StatusLabel = ({ status = '' }) => (
  <span className="tickets-index-page__status-label">
    {statusConfig[status].icon}
    {I18n.t(`tickets.statuses.${status}`)}
  </span>
);

StatusLabel.propTypes = {
  status: string,
};

export default StatusLabel;
